import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import styled from 'styled-components'
import Title from '../title'
import Description from '../description'
import AnimatedBorder from '../animated-border'
import { mobile, tablet, desktop } from '../../utils/media'

export default ({ linkTo, thumb, title, description, ...props }) => (
  <StyledLink to={linkTo}>
    <ResponsiveImage sizes={thumb} />
    <Text>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Text>
  </StyledLink>
)

const StyledLink = styled(Link)`
  position: relative;
  display: block;
  padding-bottom: 81.56%;
  width: 100vw;
  height: 170px;
  border-top: 1px solid white;
  overflow: hidden;

  :hover > div {
    opacity: .7;
  }

  ${mobile`
    width: 50vw;
    height: 315px;
    border: none;
  `}

  ${tablet`
    height: 420px;
  `}

  ${desktop`
    height: 600px;
  `}
`

const Text = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 10%;
  background-color: #000;
  transition: opacity .5s;
  opacity: .7;

  ${tablet`
    opacity: 0;
    padding: 0;
  `}
`

const ResponsiveImage = styled(Img)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`




// WEBPACK FOOTER //
// ./src/components/preview/second.js